<template>
    <div class="upload-container">
      <h1 class="title">上传视频文件，支持拖动上传</h1>
      <div class="upload-box">
        <input type="file" @change="uploadFile" id="file" class="inputfile" />
        <label for="file" class="btn-primary">选择一个文件</label>
        <p class="file-name"></p>
      </div>
    </div>
  </template>

<script>

import { BASE_URL } from "@/config";
import axios from "axios";
import MessageUtil from "@/utils/MessageUtil";

export default {
  name: "UploadVideo",

  axios: axios,

  methods: {
    uploadFile(e) {
      const file = e.target.files[0];

        // 如果文件长度大于30MB，则提示用户
        if (file.size > 30 * 1024 * 1024) {
            MessageUtil.error("文件大小不能超过10MB");
            return;
        }

        // 如果文件类型不是视频，则提示用户
        if (!file.type.startsWith("video")) {
            MessageUtil.error("只能上传视频文件");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        
        axios.post( BASE_URL + "/upload_raw_video", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          console.log(response); // 你可以在这里处理服务器的响应
        })
        .catch(error => {
          console.error(error); // 如果有错误，你可以在这里处理
        });
    }
  }
};
</script>

<style scoped>
  .upload-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #f2f2f2;
  }

  .title {
    margin-bottom: 2em;
    color: #333;
    font-size: 2em;
  }

  .upload-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .inputfile {
    display: none;
  }

  .btn-primary {
    padding: 10px 20px;
    color: white;
    background-color: #007bff;
    border-radius: 5px;
    cursor: pointer;
  }

  .file-name {
    margin-top: 1em;
    color: #666;
  }
</style>